import { debounce, type DebouncedFunc } from 'lodash';
import { useMemo, useRef, useEffect } from 'react';

type Callback = (...args: any[]) => void | Promise<void>;

export default function useDebounce<T extends Callback>(callback: T, delay = 1000): DebouncedFunc<T> {
  const ref = useRef<Callback>();

  const debounceCallback = useMemo(() => {
    const func: Callback = (args) => {
      ref.current?.(args);
    };

    return debounce(func, delay);
  }, []);

  useEffect(() => {
    ref.current = callback;
  }, [callback]);

  return debounceCallback;
}
